import { useQuery } from "react-query";
import axios from "axios";

import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const getData = async (extraKeys, callback) => {
    let extendedPath = "";
    if (extraKeys) {
        extendedPath = extraKeys.join("/");
    }
    const {data} = await axios.get(
      `${apiSitePrefix}/scratchpadusers/list/${extendedPath}`
    );
    if (callback) callback(data, extraKeys);
    return data;
};

export default function useScratchpadUsers(props) {
    // const options = {
    //     ...props.options
    // }
    let key = ['ScratchPadUsers'];
    if (props.extraKeys) {
        key = [
            ...key,
            ...props.extraKeys
        ]
    }
    const queryKey = [...key];

    return useQuery(queryKey, () => getData(props.extraKeys, props.callback));
}